import { useState } from 'react';
import { GitHubIcon, TwitterIcon, LinkedInIcon, WeChatIcon } from '../components/icons/SocialIcons';
import { useLanguage } from '../contexts/LanguageContext';
import logoImg from '../assets/dason-logo.jpg';
import SubscribeModal from '../components/SubscribeModal';

const socialLinks = [
  {
    label: 'GitHub',
    href: '#',
    icon: <GitHubIcon className="w-5 h-5" />,
  },
  {
    label: 'Twitter',
    href: '#',
    icon: <TwitterIcon className="w-5 h-5" />,
  },
  {
    label: 'LinkedIn',
    href: '#',
    icon: <LinkedInIcon className="w-5 h-5" />,
  },
  {
    label: '微信',
    href: '#',
    icon: <WeChatIcon className="w-5 h-5" />,
  },
];

export default function Footer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <>
      <footer className="relative border-t border-white/10 bg-[#0a0a0f]/30 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-12">
          <div className="flex flex-col lg:flex-row justify-between items-start gap-12 mb-20">
            {/* 1. Brand Section (Left) */}
            <div className="max-w-md flex flex-col gap-6">
              <a href="#home" className="flex items-center gap-3 w-fit group">
                <div className="relative w-11 h-11 flex items-center justify-center rounded-xl overflow-hidden shadow-lg">
                  <img src={logoImg} alt="DASON AI Logo" className="w-full h-full object-contain" />
                </div>
                <span className="text-2xl font-bold text-[var(--ds-text-primary)] tracking-wide">
                  {t.navbar.logo}
                </span>
              </a>
              <p className="text-[var(--ds-text-secondary)] text-sm leading-7 opacity-80 text-justify">
                {t.footer.slogan}
              </p>
            </div>

            {/* 2. Newsletter Button & Social (Right) */}
            <div className="flex flex-col gap-8 lg:items-end w-full lg:w-auto mt-2 lg:mt-0">
              <div className="w-full max-w-sm">
                <h4 className="text-xs font-bold text-[var(--ds-text-primary)] mb-4 uppercase tracking-widest opacity-80">
                  {t.footer.subscribeTitle}
                </h4>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="w-full h-11 flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[var(--ds-accent-purple)] to-[var(--ds-accent-indigo)] text-white font-medium text-sm hover:shadow-glow-purple hover:scale-[1.02] transition-all cursor-pointer"
                >
                  {t.cta.button}
                </button>
              </div>

              <div className="flex flex-col gap-4 lg:items-end">
                <h4 className="text-xs font-bold text-[var(--ds-text-primary)] uppercase tracking-widest opacity-80">SOCIAL MEDIA</h4>
                <div className="flex gap-4">
                  {socialLinks.map((link) => (
                    <a
                      key={link.label}
                      href={link.href}
                      className="w-10 h-10 rounded-full bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.08)] flex items-center justify-center text-[var(--ds-text-secondary)] hover:text-white hover:border-[var(--ds-accent-purple)] hover:bg-[var(--ds-accent-purple)] transition-all duration-300 hover:scale-110"
                      aria-label={link.label}
                    >
                      <span className="transform scale-100">{link.icon}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-[rgba(255,255,255,0.08)] text-center">
            <p className="text-xs text-[var(--ds-text-secondary)] tracking-wide opacity-60">
              {t.footer.rights}
            </p>
          </div>
        </div>
      </footer>

      {/* Subscribe Modal */}
      <SubscribeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}
